import { useTerritoryQueries } from 'hooks-queries/territory'

import type { IUseTerritoryParams, TUseTerritoriesFavoriteTotalReturn } from './types'

export const useTerritoriesFavoriteTotal = (props: IUseTerritoryParams): TUseTerritoriesFavoriteTotalReturn => {
  const { data, error, loading, refetch } = useTerritoryQueries({
    queryName: 'getFavoritesTerritoriesTotal',
    errorLog: props.errorLog,
  })

  const territoriesFavoriteTotal = data?.getWorkspace?.followedTerritories?.totalCount || 0

  return {
    territoriesFavoriteTotal,
    loading,
    error,
    refetch,
  }
}
